import immutable from 'immutable';
import { Tags } from './util/constants';
import {
  GET_MY_TEMPLATE_FAIL,
  GET_MY_TEMPLATE_REQUEST,
  GET_MY_TEMPLATE_SUCCESS,
} from './action';

const init = () => {
  const initValue = immutable.fromJS({
    myTemplate: undefined,
  });

  return initValue.set('myTemplate', {
    info: [],
    tags: Tags,
    isLoading: false,
  });
};

export default function myTemplateReducer(state = init(), action) {
  switch (action.type) {
    case GET_MY_TEMPLATE_REQUEST:
      return state.update('myTemplate', (myTemplate) => ({
        ...myTemplate,
        isLoading: true,
      }));
    case GET_MY_TEMPLATE_SUCCESS: {
      const { payload } = action;
      return state.update('myTemplate', (myTemplate) => ({
        ...myTemplate,
        info: payload,
        isLoading: false,
      }));
    }
    case GET_MY_TEMPLATE_FAIL:
      return state.update('myTemplate', (myTemplate) => ({
        ...myTemplate,
        isLoading: false,
      }));
    default:
      return state;
  }
}
